module.exports = "<h1>Sowwy</h1>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/sorry/sorry.html
// module id = 98
// module chunks = 0